@if (open) {
  <div class="govco-confirm-backdrop" aria-hidden="true"></div>
  <section class="govco-confirm-modal" role="alertdialog" aria-modal="true" aria-labelledby="govco-confirm-title" aria-describedby="govco-confirm-message">
    <span class="govco-confirm-icon" [class.success]="variant === 'success'" aria-hidden="true">{{ variant === 'success' ? '✓' : '!' }}</span>
    <h2 id="govco-confirm-title">{{ title }}</h2>
    <p id="govco-confirm-message">{{ message }}</p>
    <div class="govco-confirm-actions">
      @if (showCancel) {
        <button type="button" class="btn-govco secondary" (click)="closed.emit()">{{ cancelLabel }}</button>
      }
      <button type="button" class="btn-govco" (click)="confirmed.emit()">{{ confirmLabel }}</button>
    </div>
  </section>
}
